
export default {
  steps: {
    instruction: 'Instruction',
    on: 'On',
    step: 'step',
    gotoStep: 'Go to step'
  }
}
